var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-forms"}},[_c('v-form',{ref:"validateform",attrs:{"lazy-validation":""},model:{value:(_vm.formdata.valid),callback:function ($$v) {_vm.$set(_vm.formdata, "valid", $$v)},expression:"formdata.valid"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da5af5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/document/folderForm.vue
// module id = null
// module chunks = 